module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troendelag_neg.fd2880e1.png";